import { put, select } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { getSessionLinks } from 'rdx/modules/auth/slice';
import { setUser } from 'rdx/modules/users/slice';

function* getUser() {
  const { profile } = yield select(getSessionLinks);
  const { success, data, error } = yield* makeRequest.link(profile);
  if (success) {
    yield put(setUser(data.unwrap()));
  } else if (error) {
    yield* putErrorActions({ error });
  }
  return null;
}

export default getUser;
